import { createSlice } from "@reduxjs/toolkit";


const initialState: any = {
    inventory: [],
    loading: false,
    error: null,
  };
const inventorySlice = createSlice({
    name: "inventory",
    initialState,
    reducers: {
        inventoryRequest(state) {
        state.loading = true;
        state.error = null;
      },
      inventorySuccess(state, action) {
        state.loading = false;
        state.inventory = action.payload;
      },
      inventoryAddSuccess(state, action) {
        state.loading = false;
        state.inventory.push(action.payload);
      },
      inventoryEditSuccess(state, action) {
        state.loading = false;
        state.inventory = state.inventory.map((inventory: { id: any; }) =>
          inventory.id === action.payload.id ? action.payload : inventory
        );
      },
      inventoryDeleteSuccess(state, action) {
        state.loading = false;
        state.inventory = state.inventory.filter((inventory: { id: any; }) => inventory.id !== action.payload);
      },
      inventoryError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },getInventoryByIdRequest(state) {
        state.loading = true;
        state.error = null;
      },
      getInventoryByIdSuccess(state, action) {
        state.loading = false;
        state.user = action.payload;  // Store the user fetched by ID in `user`
      },
      getInventoryByIdError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
      
    },
  });

  export const {
      inventoryRequest,
      inventorySuccess,
      inventoryAddSuccess,
      inventoryEditSuccess,
      inventoryDeleteSuccess,
      inventoryError,
      getInventoryByIdRequest,
      getInventoryByIdSuccess,
      getInventoryByIdError
  } = inventorySlice.actions;

export default inventorySlice.reducer;
  